import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { PopoverBody, Popover, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import Card from '../Card/Card';
import { startSetLandingsInfo } from '../../actions/offers';

class PreviewPopover extends Component {
  state = {
    loading: false,
  };

  loadInfo = () => {
    const { offerId, id, startSetLandingsInfo, landingsInfo } = this.props;
    if (!landingsInfo[id]) {
      startSetLandingsInfo({ landingId: id, offerId }).finally(() =>
        this.setState(() => ({ loading: false })),
      );
    } else {
      this.setState(() => ({ loading: false }));
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.loading && this.state.loading) {
      this.loadInfo();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { landingsInfo, id } = this.props;
    if ((nextProps.isOpen && !landingsInfo[id]) || (landingsInfo[id] && !landingsInfo[id].error)) {
      this.setState(() => ({ loading: true }));
    }
  }

  render() {
    const { target, offerId, id, isOpen, toggle, landingsInfo } = this.props;
    const { loading } = this.state;
    const info = landingsInfo[id];
    return (
      <Popover
        className="preview-popover"
        placement="left"
        target={target}
        toggle={toggle}
        isOpen={isOpen}
      >
        <PopoverHeader>
          <FMessage id="preview.popup.header" />
        </PopoverHeader>
        <PopoverBody>
          <Card loading={loading} className={info && info.error ? 'error' : ''}>
            {/* {id === 0 ?
              <Link
                to={`/preview/${id}/?offer=${offerId}`}
                target="_blank"
              >
                {info && info.preview && <img src={info.preview}/>}
              </Link>
              :
              <Link
                to={`/preview/${id}/`}
                target="_blank"
              >
              </Link>} */}
            {info && info.preview && <img src={info.preview} />}
            {info && info.error && info.error}
          </Card>
        </PopoverBody>
      </Popover>
    );
  }
}

const mapStateToProps = (state) => ({
  landingsInfo: state.offers.landingsInfo,
});

const mapDispatchToProps = (dispatch) => ({
  startSetLandingsInfo: (params) => dispatch(startSetLandingsInfo(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewPopover);
